var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedIn = function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 30.601C34 32.48 32.465 34 30.573 34H3.427C1.533 34 0 32.478 0 30.601V3.4C0 1.522 1.535 0 3.427 0h27.146C32.467 0 34 1.522 34 3.399V30.6Z",
    fill: "#2867B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.06 8.314c0 1.249-.933 2.261-2.467 2.261-1.444 0-2.377-1.012-2.377-2.261s.963-2.261 2.438-2.261 2.377.98 2.407 2.26ZM6.337 26.902V12.357h4.575v14.545H6.336ZM13.648 16.997c0-1.813-.06-3.33-.12-4.64H17.5l.212 2.023h.09c.602-.951 2.077-2.349 4.545-2.349 3.01 0 5.266 1.994 5.266 6.276v8.595H23.04v-8.06c0-1.874-.662-3.152-2.317-3.152-1.264 0-2.016.862-2.348 1.694-.12.297-.15.714-.15 1.13V26.9H13.65v-9.905l-.002.002Z",
    fill: "#fff"
  })));
};
export default SvgLinkedIn;